<nav
  class="flex flex-col"
  [attr.aria-label]="'features.plan.deploy.channels_heading' | translate">
  <p
    class="text-text-tertiary border-weak border-b px-3 py-2 text-[10.5px] font-semibold tracking-wider uppercase">
    {{ 'features.plan.deploy.channels_heading' | translate }}
  </p>

  @for (item of configs(); track item.id) {
    @let pills = pillsFor(item);
    @let active = selectedId() === item.id;
    <button
      type="button"
      data-testid="deploy-channel-item"
      [attr.data-config-id]="item.id"
      [attr.aria-current]="active"
      class="border-weak flex w-full cursor-pointer items-start gap-2.5 border-b border-l-2 px-3 py-2.5 text-left transition-colors"
      [class]="
        active
          ? 'border-l-accent-main bg-accent-interactive text-accent-main'
          : 'hover:bg-interactive border-l-transparent'
      "
      [class.opacity-60]="!item.isEnabled"
      (click)="selectConfig.emit(item)">
      <i [class]="getChannelMeta(item.channel).icon" class="mt-0.5 shrink-0 text-sm"></i>

      <span class="flex min-w-0 flex-1 flex-col gap-0.5">
        <span class="truncate text-xs font-semibold">{{ item.name }}</span>
        <span class="text-text-tertiary truncate text-[10.5px]">
          {{ getChannelMeta(item.channel).labelKey | translate }}
        </span>
        @if (pills.length > 0) {
          <span class="mt-0.5 flex flex-wrap items-center gap-1">
            @for (pill of pills; track pill.key) {
              <app-status-pill [variant]="pill.variant" [dot]="true">
                {{ pill.key | translate: pill.params }}
              </app-status-pill>
            }
          </span>
        }
      </span>
    </button>
  }
</nav>
